module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Acknowledgments-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "frontmatter acknowledgments",
      "id": "Acknowledgements1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block5"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("I am forever grateful to Stephany Evans—the first person to believe in me—and to my editor, Madeleine Colavita, who has helped me grow as a writer with each book. A big thank you once again to Ray and Brijet Whitney for their hockey research help. You guys are wonderful. My family continues to be my greatest support system and I couldn’t do this without them—Reagan and Jacob, I love you! And a big hug to my readers of this series who love the Westmores as much as I do—especially Becca Johnson, who shared her family’s Christmas candy recipe with me. It is now a Westmore tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "signature-fm-rw",
    attrs: {
      "id": "signature1"
    }
  }, [_vm._v("XO,")]), _vm._v(" "), _c('p', {
    staticClass: "signature-continued-fm-rw",
    attrs: {
      "id": "signature2"
    }
  }, [_vm._v("Jen")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78970b61","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s005-Acknowledgments-01.vue
// module id = 75
// module chunks = 0